$(document).ready(function () {
  const storeCode = sessionStorage.getItem('cart_store_code');
  const currentPath = window.location.pathname;
  console.log('currentPath',currentPath)
  if (currentPath === '/pages/add-store-code' && storeCode) {
    // Check cart note to decide if redirect needed
    $.getJSON('/cart.js', function (cart) {
      const currentNote = cart.note ? cart.note.trim() : '';
      const desiredNote = `Store Code: ${storeCode}`;

      if (currentNote === desiredNote) {
        // Already applied, redirect to home page
        window.location.href = '/';
        return; // Stop further execution after redirect
      }
    });
  }

  if (storeCode) {
    // Prefill the input field if it exists
    $('#store-code').val(storeCode);

    // Fetch current cart data
    $.getJSON('/cart.js', function (cart) {
      const currentNote = cart.note ? cart.note.trim() : '';
      const desiredNote = `Store Code: ${storeCode}`;

      if (currentNote !== desiredNote) {
        // Update cart note
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          contentType: 'application/json',
          dataType: 'json',
          data: JSON.stringify({ note: desiredNote }),
          success: function () {
            window.location.href = '/';
            console.log('Cart note updated with store code from sessionStorage.');
          },
          error: function (xhr, status, error) {
            console.error('Error updating cart note:', error);
          }
        });
      }
    });
  }

  // Handle form submission
  $('#store-code-form').on('submit', function (e) {
    e.preventDefault();

    const newStoreCode = $('#store-code').val().trim();
    const $message = $('#store-code-message');

    if (!newStoreCode) {
      $message.text('Please enter a store code.');
      return;
    }

    // Save to session storage
    sessionStorage.setItem('cart_store_code', newStoreCode);

    // Update cart note
    $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    contentType: 'application/json',
    dataType: 'json',
    data: JSON.stringify({ note: `Store Code: ${newStoreCode}` }),
    success: function () {
      let countdown = 2;
      const interval = setInterval(function () {
        $('#store-code-message')
          .text(`Store code added. Redirecting to home page in ${countdown}…`);
        countdown -= 1;
        if (countdown < 0) {
          clearInterval(interval);
          window.location.href = '/';
        }
      }, 1000);
    },
    error: function () {
      $('#store-code-message').text('Failed to apply store code. Please try again.');
    }
    });

  });
});
